import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {InputComponent} from "@components/input";

export type InputType = 'text' | 'password' | 'email' | 'number' | 'search' | 'tel' | 'url' | 'date' | 'time' | 'datetime-local' | 'month' | 'week';
@Component({
    selector: 'msf-input',
    imports: [
    ReactiveFormsModule,
    FormsModule,
    InputComponent
],
    templateUrl: './input.html',
    styleUrl: './input.scss',
    standalone: true,
})
export class MsfInput {

    @Input({required:true}) model: any;
    @Input() label: string = ''
    @Input() step: string = ''
    @Input() maxFractionDigits: number = 2
    @Input() placeholder: string = ''
    @Input()  type: InputType = 'text';
    @Input()disabled: boolean = false;
    @Input() min: number = 0;
    @Input() decimalSeparator: '.' | ',' | null = null;

    @Output() modelChange = new EventEmitter<any>();
    @Output() onBlur = new EventEmitter<any>();
    @Output() onDecimalSeparatorUsed = new EventEmitter<'.' | ','>();
    @Output() onSeparatorMismatch = new EventEmitter<'.' | ','>();


}
